import { MyLoanInfo } from "pages/application/applicationService";

/** Canonical Encompass loan key until API exposes explicit `loanKey` (VE-01 S11). */
export const getLoanKey = (loan: MyLoanInfo): string =>
  loan.encompassLoanId ?? loan.loanId ?? loan.nhDealApplicationId;
